<button
  (click)="onAction()"
  [title]="'frame.personal_content_plugin_button' | transloco"
  id="all_toolbar_btn_toggle-favorites-sidenav"
  mat-icon-button
>
  <mat-icon class="fill">star</mat-icon>
</button>
